<template>
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign" :style="setStyles">
    <t-form-item :label="option.attribute.label" class="my_select" :style="setStyles">
      <t-select :options="options" v-model="checkedVal" class="my_select_item" :style="setStyles"
        :placeholder="option.attribute.placeholder" @change="clickHandler" :multiple="option.attribute.multiple"
        :status="message" :tips="tips" clearable :filterable="option.attribute.filterable"
        :showArrow="option.attribute.timeIcon"
        :popupProps='{ overlayClassName: "my_select_popup", overlayStyle: setStyles }' @InputChange="InputChange" />
    </t-form-item>
  </t-form>
</template>

<script>
import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-select",
  props: {
    option: Object,
    components: Array,
    current: Object,
  },
  // mixins: [mixinsCom], 
  data() {
    return {
      options: [],
      uuid: null,
      checkedVal: null,
      newData: "",
      jsFunFlag: false,
      message: "default",
      tips: "",
    }
  },
  watch: {
    // 'option.attribute': {
    //   handler(obj) {
    //     this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
    //   },
    //   deep: true,
    // },
    "current.cptShow"(val) {
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  mounted() {
    //编辑界面需要展示所有组合控件 ，但是预览界面需要初始隐藏
    if (this.$route.name != "design") {
      //  console.log(this.components,'components')
      // 默认要组合控件，但是初始化的时候，需要先隐藏，所以需要更改组合控件的属性
      this.components.forEach((component) => {
        let item = component.cptOption.attribute.typeInputSearch;
        if (item && component.typeInputSearch !== '' && component.cptKey !== 'cpt-select' && (component.cptKey !== 'cpt-button' || component.cptOption.attribute.buttonGroupType != '1')) {
          // component.cptShow = false;
        }
      })
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    console.log('123123')
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    // console.log(this.option.attribute,'this.option.attribute')
    if (!this.option.attribute.noQuery || this.dataReload.includes(0)) {
      this.refreshCptData();
    }

    // 后期添加的 filterable，兼容旧数据
    if (!this.option.attribute.hasOwnProperty('filterable')) {
      console.log(';0000')
      this.option.attribute.filterable = true
    }
    if (!this.option.cptDataForm.hasOwnProperty('isCache')) {
      this.option.cptDataForm['isCache'] = false
    }
  },
  computed: {
    // cptData() {  //组件绑定的属性
    //   console.log("======textres====",this.option.cptDataForm.resData);
    //   if(this.option.cptDataForm.resData){
    //       return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
    //   }
    // },

    // iptVal: {  //组件绑定的属性
    //   get() {
    //     if(this.option.cptDataForm.resData){
    //         return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
    //     }
    //   },
    //   set(newValue) {
    //     this.option.cptDataForm.resData = {value:newValue,options:this.options}
    //   }
    // },
    setStyles() {
      return {
        // "--labelWidth":this.option.attribute.labelWidth + "px",
        "--width": this.option.attribute.width + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--align": this.option.attribute.align,
        "--disableColor": this.option.attribute.disableColor,
        "--activeBgColor": this.option.attribute.activeBgColor,
        "--marginLeft": this.option.attribute.labelBoolean && this.option.attribute.labelAlign != 'top' ? this.option.attribute.labelWidth + "px" : '0px',
        "--labelWidth": this.option.attribute.labelWidth + "px",
        "--labelBoolean": this.option.attribute.labelBoolean ? 'block' : 'none',
        '--optionBg': this.option.attribute.optionBg,
        '--optionColor': this.option.attribute.optionColor,
        '--optionFontSize': this.option.attribute.optionFontSize + 'px',
        '--optionSelectedBg': this.option.attribute.optionSelectedBg,
        '--optionSelectedColor': this.option.attribute.optionSelectedColor,
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        this.loadData(cptDataForm, paras)
      }, this.components)
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        // that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag)    //监听里面会执行的
        // console.log(that.jsFunFlag)
      },)
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      console.log('processData222222')
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        // if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return

        // console.log(res, 'res')
        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据
        if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
          const dataKey = this.option.attribute.cptTableData;
          // 创建一个新的数组用于存储结果
          let newres = [];
          if (!Array.isArray(res) && res.options) {
            // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
            res.options.forEach(item => {
              let newItem = {};
              dataKey.forEach(mapping => {
                newItem[mapping.namekey] = item[mapping.value];
              });
              // 合并原有的键值对
              Object.assign(newItem, item);
              newres.push(newItem);
            });

          } else {
            // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
            res.forEach(item => {
              let newItem = {};
              dataKey.forEach(mapping => {
                newItem[mapping.namekey] = item[mapping.value];
              });
              // 合并原有的键值对
              Object.assign(newItem, item);
              newres.push(newItem);
            });
          }


          let newObject = {
            value: [],
            options: newres
          };
          // this.newData = newObject;

          if (newObject) {
            this.funselect(newObject);
          }

        }
        // } else { // 如果配置了转换脚本
        //   if (res) {
        //     this.funselect(res);
        //   }
        // }
      } else { // 不是数据集类型，是静态数据
        // if (res)
        //   this.funselect(res);

        let otherData = res && res.hasOwnProperty('value') && res.hasOwnProperty('options')

        this.funselect(otherData ? res : this.newData);
      }
    },
    funselect(res) {
      if (res.options) {
        this.options = res.options;
      }
      const defaultValue = getDefaultValue(this.option.attribute)
      // console.log(res.options,'res.options')
      let isDefaultValue = res.options?.find(({ value }) => value == defaultValue)


      if (isDefaultValue) {
        this.checkedVal = isDefaultValue.value
      } else {
        this.checkedVal = res.value || res.options[0].value;
      }
      this.clickHandler(this.checkedVal)

      // 源代码 2024-8-20
      // if (isDefaultValue) {
      //   this.checkedVal = defaultValue
      // } else {
      //   this.checkedVal = res.value;
      // }
      // if(res.value !== undefined && res.value !== '' && this.current.id !== '3f74ad70-11c7-11ef-be9f-873c49539d87'){
      // if (res.value !== undefined && res.value !== '') {
      //   if (res.options.length) {
      //     this.checkedVal = res.options[0].value
      //     // this.clickHandler(this.checkedVal)
      //   }
      //   console.log(res.options, this.checkedVal, 'checkedValcheckedValcheckedVal');
      //   this.clickHandler(this.checkedVal)
      // }


      if (this.current.id == '3f74ad70-11c7-11ef-be9f-873c49539d87') {
        console.log(res, 'this.current.id')
        this.checkedVal = res.options[0]?.value;
        setTimeout(() => {
          this.clickHandler(this.checkedVal)
        }, 300)

      }


    },
    clickHandler(val) {
      setTimeout(() => {
        this.$emit("clickHandler", this.option.interaction, val, val, 'cpt-select', val)
      }, 300)
      this.checkValue();
      //文本搜索控件组合了下拉框，要写一些定制化代码，例如显示隐藏
      // if (this.$route.name != "design"){
      //   if (Array.isArray(this.current.group) && this.current.group.length > 0) {
      //     console.log('change')
      //       this.showHideMethod(val);
      //   }
      // }
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      if (attribute.required && !this.checkedVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
    },
    setValue(value) {
      this.checkedVal = value
    },
    getValue() {
      return this.checkedVal
    },
    InputChange(val) {
      //文本搜索控件组合了下拉框，要写一些定制化代码，例如显示隐藏
      // if (this.$route.name != "design"){
      //   if (Array.isArray(this.current.group) && this.current.group.length > 0) {
      //     console.log('input')
      //     this.showHideMethod(val);
      //   }
      // }
    },
    showHideMethod(val) {
      console.log(val, 'val')
      if (val != '') {
        if (Array.isArray(this.components) && this.components.length > 0) {
          this.components.forEach(item => {
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-text') {
              item.cptShow = false;
            }
            if (this.current.group.includes(item.id) && item.cptOption.attribute.buttonGroupType == 3 && item.cptKey === 'cpt-button') {
              item.cptShow = false;
            }
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-radio') {
              item.cptShow = false;
            }
          });
        }
      } else {
        if (Array.isArray(this.components) && this.components.length > 0) {
          this.components.forEach(item => {
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-text') {
              item.cptShow = true;
            }
            if (this.current.group.includes(item.id) && item.cptOption.attribute.buttonGroupType == 3 && item.cptKey === 'cpt-button') {
              item.cptShow = true;
            }
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-radio') {
              item.cptShow = true;
            }
          });
        }
      }
    }
  },
}
</script>
<style>
.my_select_popup .t-select-option {
  background: var(--optionBg);
  color: var(--optionColor);
}

.my_select_popup .t-select-option span {
  font-size: var(--optionFontSize);
  font-family: var(--fontFamily);
}

.my_select_popup .t-is-selected {
  background: var(--optionSelectedBg) !important;
  color: var(--optionSelectedColor) !important;
  font-family: var(--fontFamily);
}

.my_select .t-form__label label {
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  line-height: var(--height);
  display: var(--labelBoolean);
  /* width: var(--labelWidth) !important; */
}

.t-form .my_select .t-form__controls {
  margin-left: 0px !important;
}

.my_select_item .t-input .t-input__inner::placeholder {
  color: var(--placholderColor);
}

.my_select_item .t-input .t-input__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  text-align: var(--align);
}

.my_select_item .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  /* width: var(--width);  */
  min-height: var(--height);
}

.my_select_item .t-input:focus {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_select_item .t-input:hover {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_select_item .t-input--focused {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_select_item .t-is-focused {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

:deep(.t-select .t-fake-arrow) {
  color: var(--disableColor) !important;
}

:deep(.t-select .t-fake-arrow--active) {
  color: var(--activeBgColor) !important;
}
</style>
